<template>
  <b-modal
    id="modal-view-more-material"
    :title="$t('watch_material')"
    :ok-title="$t('general.close')"
    :ok-variant="'success'"
    centered
    ok-only
    no-close-on-backdrop
    size="lg"
  >
    <!-- @ok="" -->

      <b-table
        ref="selectableTable"
        class="border"
        selectable
        select-mode="single"
        :items="items"
        :fields="fields"
        responsive
        :empty-text="$t('empty_text')"
        show-empty
        @row-clicked="onRowSelected"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(value)="props">
          <span>{{ props.item.value }}</span>
        </template>

        <template #cell(unity)="props">
          <span>{{ props.item.unity }}</span>
        </template>

        <template #cell(min_unity)="props">
          <span>{{ props.item.min_unity }}</span>
        </template>

        <template #cell(min_qty)="props">
          <span>{{ props.item.min_qty }}</span>
        </template>

        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <feather-icon icon="CheckIcon" />
          </template>

          <template v-else />

        </template>
      </b-table>

  </b-modal>
</template>

<script>
import {
  VBModal,
  BModal,
  BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    BModal,
    BTable,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    viewMaterial: {
      type: [Object],
      required: true
    }
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION START ===============
      items: [],
      fields: [
        {
          label: '№',
          key: 'id',
        },
        {
          label: 'reference.name',
          key: 'value',
        },
        {
          label: 'reference.unit',
          key: 'unity',
        },
        {
          label: 'reference.packaging',
          key: 'min_unity',
        },
        {
          label: 'reference.multipliers',
          key: 'min_qty',
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============




    }
  },
  watch: {  



    // ===============  PRIMARY_WATCHERS_SECTION START ===============
    viewMaterial(newValue){
      this.items = []
      this.items.push(newValue)
    }
    // ===============  PRIMARY_WATCHERS_SECTION END ===============



  },
  computed: {
  },
  async mounted() {

  },
  methods: {




    // ===============  PRIMARY_METHODS_SECTION START ===============
    onRowSelected(item) {

    },
    // ===============  PRIMARY_METHODS_SECTION END ===============




  },
}
</script>



<style>
.table-materials .table.b-table > tbody > .table-active, [dir] .table.b-table > tbody > .table-active > th, [dir] .table.b-table > tbody > .table-active > td {
  color: #fff;
  background-color: #5a9cd9 !important;
}




.activeList {
  background: #5a9cd9 !important;
  color: #fff !important;
}

.activeList svg:nth-child(1) {
  color: #fff;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.flex span {
  width: 69%;
  text-align: left;
  user-select: none;
}

.mt-25px {
  margin-top: 25px
}
</style>
